export const CURRENT_AD_QUERY = (id: number): [current: 'current-ad', id: number] => [
  'current-ad',
  id
];
export const PERFORMANCE_AD_QUERY = (id: number): [current: 'performance-ad', id: number] => [
  'performance-ad',
  id
];

export const QUALITY_AD_QUERY = (id: number): [current: 'quality-ad', id: number] => [
  'quality-ad',
  id
];
export const LISTING_QUERY = 'listing';
export const DELETE_STATUS_QUERY = 'delete-status';
export const SEND_FEEDBACK_MUTATION = 'send-feedback';
export const GET_COLORS = 'get-colors';
export const GET_DESCRIPTION_ITEMS = 'itens-descricao';
export const GET_OPTIONALS = 'get-optionals';
export const GET_FUELS = 'get-fuels';
export const GET_DOORS = 'get-doors';
export const GET_PRICE_SUGGESTIONS = 'get-price-suggestions';
export const GET_VEHICLE_VERSIONS = 'get-vehicle-versions';
export const GET_CONFIGURATIONS = 'configurations-client';
export const RENEW_MUTATION_QUERY = 'renew-ad-by-id';
export const POST_NPS_QUERY = 'post-nps';
export const PUT_NPS_QUERY = 'put-nps';
